
export enum emotions {
    Anger="Anger",
    Calm="Calm",
    Fear="Fear",
    Disgust="Disgust",
    Joy="Joy",
    Sad="Sad"
}